import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { unit } from '../propTypes'
import { unitMap, unitOptions } from '../utils'

import ProgressSteps from './ProgressSteps'
import Toggle from './Toggle'

export default class TotalsPanel extends Component {
  static propTypes = {
    buildingCosts: PropTypes.string.isRequired,
    grossDevelopmentValue: PropTypes.string.isRequired,
    gotoStage: PropTypes.func.isRequired,
    landValue: PropTypes.string.isRequired,
    landValuePerUnitArea: PropTypes.string,
    showEditButtons: PropTypes.bool,
    stage: PropTypes.number.isRequired,
    totalCosts: PropTypes.string.isRequired,
    totalProfit: PropTypes.string.isRequired,
    updateUnit: PropTypes.func.isRequired,
    unit: unit,
  }

  printCalculation = () => window.print()

  render() {
    const {
      buildingCosts,
      grossDevelopmentValue,
      gotoStage,
      landValue,
      landValuePerUnitArea,
      showEditButtons,
      stage,
      totalCosts,
      totalProfit,
      updateUnit,
      unit,
    } = this.props

    return (
      <div className='sidebar totals'>
        <div className='sidebar__unit-toggle hidden-mobile hidden-tablet'>
          <Toggle
            fullWidth
            onChange={updateUnit}
            options={unitOptions['metric-imperial']}
            value={unit}
          />
        </div>

        <ProgressSteps
          stage1Active={stage === 1}
          stage2Active={stage === 2}
          stage3Active={stage === 3}
          stage1Complete={grossDevelopmentValue !== '—'}
          stage2Complete={buildingCosts !== '—'}
          stage3Complete={totalCosts !== '—'}
          gotoStage={gotoStage}
        />

        <div className='running-totals'>
          <div className='running-totals__item'>
            Gross Development Value
            <div className='running-totals__amount'>{grossDevelopmentValue}</div>
          </div>
          <div className='running-totals__item'>
            Total Costs<br /><small>(includes profit)</small>
            <div className='running-totals__amount'>{totalCosts}</div>
          </div>
          <div className='running-totals__item running-totals__item--total'>
            Land Value
            <div className='running-totals__amount'>{landValue}</div>
          </div>
          <div className='running-totals__item running-totals__item--secondary'>
            Total Profit
            <div className='running-totals__amount'>{totalProfit}</div>
          </div>
          {landValuePerUnitArea && (
            <div className='running-totals__item'>
              Land value per {unitMap[`${unit}-large`]}
              <div className='running-totals__amount'>{landValuePerUnitArea}</div>
            </div>
          )}
        </div>
        {showEditButtons && (
          <div className='totals__actions'>
            <button
              className='btn btn--primary btn--outline btn--full btn--prefix--edit'
              type='button'
              onClick={() => gotoStage(1)}
            >
              Edit inputs
            </button>
            <button
              className='btn btn--primary btn--outline btn--full btn--prefix--print'
              type='button'
              onClick={this.printCalculation}
            >
              Print calculation
            </button>
          </div>
        )}
      </div>
    )
  }
}
